import shallowEqual from '@insight/toolkit-utils/lib/helpers/shallowEqual';

const filterSubscription = (
  dest,
  src,
  prev,
  subscription,
  keys,
  shallowEqualKeys
) => {
  let diff = false;
  keys.forEach((key) => {
    if (subscription[key]) {
      dest[key] = src[key];
      if (
        !prev ||
        (~shallowEqualKeys.indexOf(key)
          ? !shallowEqual(src[key], prev[key])
          : src[key] !== prev[key])
      ) {
        diff = true;
      }
    }
  });
  return diff;
};

export default filterSubscription;
